import React from "react";
import axios from 'axios';
import './Payment.css';
import Breadcrumb from '../Components/Breadcrumb';

import CartService from '../Services/cart.service';
import {   Modal,ModalHeader, ModalBody } from "reactstrap";

class Payment extends React.Component {
    constructor(props){
       
        super(props);
        this.state = {
            cartItems: [],
            cartTotal: [],
            cartGrandTotal: [],
            address:[],addModal:false,
            wallet:0, codChk:0,upiChk:0,creditChk:0,
            debitChk:0,
            checkoutLoader:'Place Order',codAddress:[]
            }
            this.label=''
            this.handleInputChange = this.handleInputChange.bind(this);
        }


    async componentDidMount(){
        this.getCart()
        //const script = document.createElement("script");
        //script.src = 'https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/jyfBoj95636358104613.js';
        
        //script.crossorigin="anonymous";
       // script.async = true;
        //document.body.appendChild(script);
    
    }
   /*  viewAddress(e){
      //e.preventDefault();
      this.setState({ addModal: true });
    } */

    async handleInputChange(e,action){
   
      //const target = e.target;
     //alert(action)
      //this.label = target.name
      if(action==='cod'){
          this.setState({codChk:1})  
          this.setState({ addModal: true });
          const USR_TOKEN = localStorage.getItem("userToken")
           

          axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.getAgentContact?pin='+localStorage.getItem('pin'),{
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({codAddress:response.data['message']})
            this.setState({check:false})

            //this.setState({address1:response.data['message'][0]})
           // console.log(response.data['message'])
        })
        .catch(response=>{
          //alert(" Sorry something went wrong. Please log in ")
       })

      }
      else{
        this.setState({codChk:0})  
      }
      if(action==='upi'){
        // alert(target.value)
           this.setState({upiChk:1})  
       }
       else{
        this.setState({upiChk:0})  
      }
       if(action==='credit'){
        // alert(target.value)
           this.setState({creditChk:1})  
       }
       else{
        this.setState({creditChk:0})  
      }
       if(action==='debit'){
        // alert(target.value)
           this.setState({debitChk:1})  
       }
       else{
        this.setState({debitChk:0})  
      }
      //this.setState({codChk:0})
    }
    async paymentProcess(e){
      e.preventDefault();   

      this.setState({ checkoutLoader:'Processing Payment...'});

         


       
              await CartService.payment_initiate()
              .then(res=>{  
                    this.setState({ checkoutLoader:'Payment Initiated...'});
                    //clear cart
                   // localStorage.removeItem('cart');
                  //  localStorage.removeItem('servercart');

                    //console.log(res.message.payment.head.signature)
                    //console.log('txnToken')
                  // console.log(res.message.payment.body.txnToken)
                    this.setState({ orderDetails:res.message.quote});
                    this.setState({ paymentDetails:res.message.payment});
                    this.setState({ txnToken:res.message.payment.body.txnToken});
                  // let url = res.message.payment.payment_link
                  // if (url)
                  //   window.location.href=url


                  


                
                  var config = {
                    "root":"",
                    "style": {
                      "bodyBackgroundColor": "#fafafb",
                      "bodyColor": "",
                      "themeBackgroundColor": "#0FB8C9",
                      "themeColor": "#ffffff",
                      "headerBackgroundColor": "#284055",
                      "headerColor": "#ffffff",
                      "errorColor": "",
                      "successColor": "",
                      "card": {
                        "padding": "",
                        "backgroundColor": ""
                      }
                    },
                    "data": {
                      "orderId": this.state.orderDetails,
                      "token": this.state.txnToken,
                      "tokenType": "TXN_TOKEN",
                      "amount": this.state.cartGrandTotal 
                    },
                    "payMode": {
                      "labels": {},
                      "filter": {
                        "exclude": []
                      },
                      "order": [
                          "CC",
                          "DC",
                          "NB",
                          "UPI",
                          "PPBL",
                          "PPI",
                          "BALANCE"
                      ]
                    },
                    "website": "DEFAULT",
                    "flow": "DEFAULT",
                    "merchant": {
                      "mid": 'Pretty74572803435608',
                      "redirect": true
                    },
                    "handler": {
                      "transactionStatus":function transactionStatus(paymentStatus){
                        console.log("paymentStatus => ",paymentStatus);
                        if(paymentStatus.STATUS === "TXN_SUCCESS"){
                           CartService.place_order()
                        }
                    
                        
                      },
                      "notifyMerchant":function notifyMerchant(eventName,data){
                        console.log("Closed");
                        
                        
                      }
                    }
                };

                        
                this.setState({ checkoutLoader:'Processing Payment...'});
                console.log("config => ",config)
                  if (window.Paytm && window.Paytm.CheckoutJS) {
                    console.log("Yes inside")
                        // initialze configuration using init method
                        window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                            console.log('Before JS Checkout invoke');
                            // after successfully update configuration invoke checkoutjs
                            window.Paytm.CheckoutJS.invoke();
                        }).catch(function onError(error) {
                            console.log("Error => ", error);
                            
                        });
                }
                      
                  
        
              })

      

    }
    async placeOrder(e){
        e.preventDefault();   

        this.setState({ checkoutLoader:'Processing Order...'});

        if(!this.state.orderDetails){
            await CartService.place_order()
            .then(res=>{  
                  this.setState({ checkoutLoader:'Order Placed...'});
                  //clear cart
                  localStorage.removeItem('cart');
                  localStorage.removeItem('servercart');

                  //console.log(res.message.payment.head.signature)
                  //console.log('txnToken')
                 // console.log(res.message.payment.body.txnToken)
                  this.setState({ orderDetails:res.message.order});
                  this.setState({ paymentDetails:res.message.payment});
                 // let url = res.message.payment.payment_link
                 // if (url)
                    window.location.href="/my-orders";
                     

                      
                            this.setState({ checkoutLoader:'Processing Payment...'});
                            
                     
                 
      
            })

        }
        
            
      
      
        
      
        
      }
      async getCart(){
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
     
          await CartService.getCart()
          .then(response=>{ 
              this.setState({quote:response['doc']['name']})
              this.setState({cartItems:response['doc']['items']})
              this.setState({cartGrandTotal:response['doc']['grand_total']})
              if(response['doc']['shipping_address']){
                this.setState({address:response['doc']['shipping_address']})
                }
          })
          .catch(err=>{ console.log(err)})

             // axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.wallet_balance',{
              //    headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
             // })
             // .then(response=>{
                 // this.setState({wallet:response.data['message']})

             // })
              
      
          
      
        }
    
      
      }

    render() {
      const USR_TYPE = localStorage.getItem("userType")

    // alert(this.state.codChk)
        if (!this.state.cartGrandTotal > 0){
            window.location.href = "/cart"
        }

        return <div>
            
        <Breadcrumb head="Checkout"/>
        <div className="container mt-2 mb-3">
                    <h2>Make Payment</h2>
                    <div className="row">
                        <div className="col-md-6 mt-2 mb-3">
                            <h6  className="small-header">Amount</h6>
                            <h2 className="total-price">Rs {this.state.cartGrandTotal}</h2>
                            {(() => {
                                  if (this.state.wallet > 0) {
                                      let payEmt
                                      this.state.wallet > this.state.cartGrandTotal? payEmt=this.state.cartGrandTotal:payEmt=this.state.wallet
                                    return (<> <h6  className="small-header pt-4">Use Wallet Amount</h6>
                                        <input value="wallet" type="checkbox" name="s"/>&nbsp;&nbsp;<label for="yes">Rs {payEmt} of Rs {this.state.wallet}</label>
                                    </>) 
                                }
                            })()}
                            </div>

                        {USR_TYPE === 'agent' ? <button type="button" className=" add-to-cart2 btnn mybtn" onClick={e => this.placeOrder(e)}>Place Order</button> :  
                        <div className="col-md-4 mt-2 mb-3">
                        <h6  className="small-header">Choose Other Payment Option</h6>
                        <ul className="subtotal subtotal-list">
                            <li className="subtotal"><input value="Credit Card" type="radio" name="credit"  onChange={(e) =>this.handleInputChange(e,'credit')}  checked={this.state.creditChk}/><p>Credit Card</p> </li>
                            <li className="subtotal"><input type="radio" name="debit"  onChange={(e) =>this.handleInputChange(e,'debit')}  checked={this.state.debitChk}/><p>Debit Card</p> </li>
                            <li className="subtotal"><input type="radio" name="upi" onChange={(e) =>this.handleInputChange(e,'upi')}  checked={this.state.upiChk}/><p>UPI</p> </li>
                            <li className="subtotal"><input type="radio" name="cod"  onChange={(e) =>this.handleInputChange(e,'cod')}  checked={this.state.codChk} /><p>Cash On Delivery</p> </li>

                        </ul>
                        {this.state.codChk==='1'?  '' : <button type="button" className=" add-to-cart2 btnn mybtn" onClick={e => this.paymentProcess(e)}>{this.state.checkoutLoader}</button>} 
                        
                        </div>}
                    </div>
                </div>    
                <Modal
                                              size="md"
                                              isOpen={this.state.addModal}
                                              toggle={() => this.setState({ addModal: false })} 
                                              show={this.state.addModal}
                                            /*  onHide={this.state.setPop} */
                                          >
                                          <ModalHeader toggle={() => this.setState({ addModal: false })}>
                                              <h3 className=" ml-2 address-titlt">Cash On Delivery</h3>
                                          </ModalHeader>
                                          <ModalBody>
                                          <div className="container ">
                                               <p><strong>For Cash On Delivery, Please contact the below address </strong></p>
                                               <div className=" btn btn-outlines ouline-space width-335"><div className="text-left">
                                                  <p className="text-left">{this.state.codAddress.contact_address}
                                                </p></div>
                                                <a href="tel:{this.state.codAddress.contact_no}"><strong>{this.state.codAddress.contact_no}</strong></a>
                                            </div>
                                                   
                                            </div>
                                          </ModalBody>
                                          </Modal>
                </div>
        
         
    }       
}

export default Payment;